import styled from 'styled-components';
import { FlexContainer } from '../../styles/Global';
import { $black, $primary } from '../../styles/Variables';
import CustomSelect from '../Form/FormItem/Select/Select';

export const StyledSelect = styled(CustomSelect)`
  .ant-select-selector {
    border-radius: 8px !important;
    padding: 1px 3px;
    min-height: 44px;

    .ant-select-selection-item {
      border: none;
      border-radius: 8px;
      padding: 14px 0;
      color: ${$black};
      background-color: transparent;
      font-size: 14px;
      line-height: 14px;
      height: 44px;

      .anticon {
        color: ${$primary};
        font-size: 9px;
      }
    }
  }

  .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    margin: auto;
  }

  .ant-select-selector .ant-select-selection-search-input {
    height: 42px !important;
  }

  .ant-select-selection-placeholder {
    margin: auto;
  }
`;

export const SearchFilterContainer = styled(FlexContainer)`
  background-color: #f9fafb;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 20px;
  gap: 16px;
  margin-bottom: 20px;
  align-items: center;
`;

export const ConditionContainer = styled.div<{ $isAdmin?: boolean }>`
  display: grid;
  gap: 16px;
  align-items: center;
  grid-template-columns: 300px 1px 200px 200px;

  ${({ $isAdmin }) =>
    $isAdmin && `grid-template-columns: 300px 1px 200px 200px 200px;`}
`;

export const VerticalLine = styled.div`
  background-color: var(--color-border-light);
  width: 1px;
  height: 20px;
`;

export const Row = styled(FlexContainer)`
  /* max-width: 1000px; */
`;

export const ChartWrapper = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ChartContainer = styled.div`
  width: 200px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const IndexContainer = styled.div`
  display: grid;
  grid-template-columns: 32px auto;
  justify-content: left;
  gap: 12px;
  border-radius: 8px;
  text-align: center;
  padding: 12px 11px;
  box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.06);

  .title {
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    color: #75777a;
    text-align: left;
  }

  .value {
    font-weight: 500;
    font-size: 24px;
    line-height: 32px;
    color: #191c1e;
    text-align: left;
  }
`;

export const CardStatsContainer = styled.div<{ isShipmentOnly?: boolean }>`
  display: grid;
  grid-template-columns: repeat(
    ${({ isShipmentOnly }) => (isShipmentOnly ? 5 : 4)},
    1fr
  );
  gap: 8px;
  align-items: center;
  margin-bottom: 20px;
  /* box-shadow: 0px 4px 18px rgba(16, 24, 40, 0.06); */
`;

export const StatsContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  gap: 24px;

  h3 {
    color: var(--color-primary-black);
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    margin-bottom: 16px;
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const SideChartsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ProductTypeTableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;

  .ant-table-cell {
    white-space: nowrap;
  }
`;

export const Wrapper = styled.div`
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 16px;
`;

export const ProductTypeStatsSection = styled(Wrapper)`
  margin-top: 24px;

  h3 {
    color: var(--color-primary-black);
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    margin-bottom: 16px;
  }
`;

export const ChartLegend = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LegendDot = styled.div<{ color: string }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
  flex-shrink: 0;
`;

export const LegendLabel = styled.span`
  font-size: 14px;
  color: #374151;
  font-weight: 500;
`;
